<div class="contenedor" style="width: 85%; margin: 0 auto;">

    <div class="titulo" style="margin-top:0 auto;text-align: center;">
        <h3>Crear Lista de Calificaciones</h3>
    </div>

    <form (ngSubmit)="Reporte(f)" #f="ngForm">

        <div class="form-row contenedorcheck mt-5">

            <div class="Calif" style="width: 250px;">

                <div class="form-group">
                    <div class="form-check">
                        <input [(ngModel)]="reporte.asignaturasx" name="asignaturasx" class="form-check-input" type="checkbox" id="gridCheck" [checked]="asignaturas" (change)="testCheckAsignaturas($event)" ngModel #asignaturasx="ngModel">
                        <label class="form-check-label" for="gridCheck">Asignaturas</label>
                    </div>

                </div>

            </div>

            <div class="Submod" style="width: 250px;">

                <div class="form-group">
                    <div class="form-check">
                        <input [(ngModel)]="reporte.submodulosx" name="submodulosx" class="form-check-input" type="checkbox" id="gridCheck2" [checked]="submodulos" (change)="testCheckSubmodulos($event)" ngModel #submodulosx="ngModel">
                        <label class="form-check-label" for="gridCheck2">Submódulos</label>
                    </div>

                </div>

            </div>

            <div class="Extra" style="width: 250px;">

                <div class="form-group">
                    <div class="form-check">
                        <input [(ngModel)]="reporte.extracurricularesx" name="extracurricularesx" class="form-check-input" type="checkbox" id="gridCheck3" [checked]="extracurriculares" (change)="testCheckExtracurriculares($event)" ngModel #extracurricularesx="ngModel">
                        <label class="form-check-label" for="gridCheck3">Extracurriculares</label>
                    </div>
                </div>

            </div>

            <div class="Todos" style="width: 250px;">

                <div class="form-group">
                    <div class="form-check">
                        <input name="todosx" class="form-check-input" type="checkbox" id="gridCheck5" [checked]="todos" (change)="testCheckTodos($event)" ngModel #todosx="ngModel">
                        <label class="form-check-label" for="gridCheck5">Todos</label>
                    </div>
                </div>

            </div>

        </div>

        <hr>

        <div class="form-row mt-5">

            <div class="form-group col-md-3">
                <label for="inputState" style="font-weight: 600;">Período</label>
                <select [(ngModel)]="reporte.periodo" name="periodo" id="inputState" class="form-control" required [class.is-invalid]="periodo.invalid && periodo.touched" ngModel #periodo="ngModel">
              <option value="{{periodo.idperiodo}}" *ngFor="let periodo of periodos">{{periodo.periodo}}-{{periodo.ciclo}}</option>
            </select>
                <small *ngIf="periodo.invalid && periodo.touched" class="form-text text-danger animated fadeIn">Obligatorio</small>
            </div>

            <div *ngIf="verinputplantel" class="form-group col-md-3">
                <label for="inputState" style="font-weight: 600;">Plantel</label>
                <input class="form-control" type="text" value="{{nombreplantel}} -- {{reporte.plantel}}" readonly>
            </div>


            <div *ngIf="vercomboplantel" class="form-group col-md-3">
                <label for="inputState" style="font-weight: 600;">Plantel</label>
                <select [(ngModel)]="reporte.plantel" name="plantelx" id="inputState" class="form-control" required [class.is-invalid]="plantelx.invalid && plantelx.touched" ngModel #plantelx="ngModel">
                    <option value="Todos">Todos</option>
                    <option value="{{plantel.idplantel}}" *ngFor="let plantel of planteles">{{plantel.nombreplantel}}</option>
            </select>
                <small *ngIf="plantelx.invalid && plantelx.touched" class="form-text text-danger animated fadeIn">Obligatorio</small>
            </div>

            <!-- <div *ngIf="verinputplantel" class="form-group col-md-3">
                <label for="inputState" style="font-weight: 600;">Plantelxx</label>
                <input [(ngModel)]="reporte.plantel" name="plantel" type="text" class="form-control" readonly>
            </div> -->

            <div class="form-group col-md-3">
                <label for="inputState" style="font-weight: 600;">Docente</label>
                <input [(ngModel)]="reporte.docente" name="docente" type="text" class="form-control" list="list-timezone" id="input-datalist" (change)="quitartodosDocentes()" ngModel #docente="ngModel">
                <datalist id="list-timezone">
                    <option value="{{docente.numempleado}}" *ngFor="let docente of getdocentes">{{docente.nombre}} {{docente.appaterno}}</option>
            
                </datalist>

                <!-- <label for="inputState" style="font-weight: 600;">Docente (Núm empleado)</label>
                <input [(ngModel)]="reporte.docente" name="docente" type="text" class="form-control" (change)="quitartodosDocentes()" ngModel #docente="ngModel"> -->
            </div>

            <div class="form-group col-md-3">
                <div class="form-check mt-3">
                    <input [(ngModel)]="reporte.todosdocentes" name="todosdocentes" class="form-check-input" type="checkbox" id="gridCheck4" [checked]="docentes" (change)="testCheckTodosDocentes($event)">
                    <label class="form-check-label" for="gridCheck4">Todos los docentes</label>
                </div>
            </div>

        </div>

        <button type="submit" class="btn btn-outline-dark">Generar Lista</button>
    </form>
</div>